import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { Waypoint } from 'react-waypoint';
import { useLegalMatterStageAutocompleteQuery } from '../../../../../queries';
import { Checkbox } from '../../../Checkbox';
import { Dropdown } from '../../../Dropdown';
import { DisclosureIcon } from '../../../svgs/icons/DisclosureIcon';
import { styleSheet as dropdownStyles } from '../../DropdownComponent/styles';
import { styleSheet } from './styles';

export const MatterStageFilterDropdown = ({
	selectedStages,
	setSelectedStages,
	anchorClassName,
}: {
	selectedStages: Api.ILegalMatterStage[];
	setSelectedStages: React.Dispatch<React.SetStateAction<Api.ILegalMatterStage[]>>;
	anchorClassName?: string;
}) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const stageAutocompleteQuery = useLegalMatterStageAutocompleteQuery({
		enabled: true,
		pageSize: 25,
		fragment: '',
	});

	const stages = React.useMemo(() => {
		return stageAutocompleteQuery.data?.pages.map(page => page.values).flat() ?? [];
	}, [stageAutocompleteQuery.data]);

	const dropdownMessage = React.useMemo(() => {
		if (selectedStages.length === 0) {
			return 'Stage';
		}
		return selectedStages.length === 1
			? selectedStages[0]?.name
			: `${selectedStages[0]?.name} +${selectedStages.length - 1}`;
	}, [selectedStages]);

	const resetFilter = () => {
		setSelectedStages([]);
	};

	const isStageSelected = (stage: Api.ILegalMatterStage) => {
		return selectedStages.some(s => s.id === stage.id);
	};

	const onToggleStage = (stage: Api.ILegalMatterStage) => {
		const isSelected = isStageSelected(stage);

		if (isSelected) {
			setSelectedStages(selectedStages.filter(s => s.id !== stage.id));
		} else {
			setSelectedStages([...selectedStages, stage]);
		}
	};

	return (
		<Dropdown
			anchor={
				<div className={css(dropdownStyles.dropdownAnchor)}>
					<span>{dropdownMessage}</span>
					<DisclosureIcon className={css(dropdownStyles.dropdownIcon)} />
				</div>
			}
			anchorClassName={anchorClassName}
			disabled={false}
			className={css(dropdownStyles.dropdownInline, isOpen ? dropdownStyles.dropdownInlineOpen : null)}
			contentClassName={css(dropdownStyles.dropdownMenu)}
			contentPositionY='bottom'
			contentInnerClassName={css(styleSheet.dropdownContentInnerOverrides)}
			isOpen={isOpen}
			onOpenChanged={() => setIsOpen(!isOpen)}
			openOnClick
		>
			<div className={css(dropdownStyles.dropdown)}>
				<div>
					{stages.map(stage => {
						return (
							<div className={css(styleSheet.dropdownRow)} key={`stage-select-${stage.id}`}>
								<Checkbox
									type='large'
									checked={isStageSelected(stage)}
									id={stage.id}
									onChange={() => onToggleStage(stage)}
								/>
								<span>{stage.name}</span>
							</div>
						);
					})}
				</div>

				{stageAutocompleteQuery.hasNextPage && <Waypoint onEnter={() => stageAutocompleteQuery.fetchNextPage()} />}
				<div className={css(dropdownStyles.dropdownSeparator)} />

				<button onClick={resetFilter}>Reset Filter</button>
			</div>
		</Dropdown>
	);
};
